import { GigaUserApi, GigaUserApiClient } from "@giga-user-fern/api";
import { RichTextData } from "../components/formats/RichText/TextEditor";
import { cleanJSON, findAllDataUriImages, insertImageMetadata } from "../components/formats/RichText/utils/cleanImageSrc";
import { Guide, GuideData, GuideHeader, GuidePreview, Organization, VideoClip, Voice } from "../core/types/guide";
import { DocStep } from "../core/types/record";
import { setBranding, getBrandingColor } from '../core/utils/styleUtils';
import { showError } from '../core/utils/DOMUtils';
import { fetcher } from "./Adapter";
import { Collection, CollectionInput } from "../core/types/collections";
import { rootCollection } from "../types/files";
import {PlainDoc} from '../core/types/guide';
import logger from "../utils/logger";
import { captureEvent } from "../core/analytics/analytics";
import { getDataUris, getHTMLandTextWithImages } from "../components/formats/RichText/utils/exportProcessing";
// import { Id } from '../core/types/baseTypes';
const Id = GigaUserApi.Id;

// let main_url = "http://localhost:8080"
// const main_url = "https://gigauser-backend.fly.dev"
let main_url = "https://api.clueso.io"
if (window){
    if (window.location.hostname === "help.desklamp.io"){
        main_url = "https://help.desklamp.io"
    }
    if (window.location.hostname === "docs.plotline.so"){
        main_url = "https://docs.plotline.so"
    }
}

// const main_url = "https://help.desklamp.io"
type PresignedUrl = any;

function dataURItoBlob(dataURI: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    
    try {
        
        var byteString = atob(dataURI.split(",")[1]);

        // separate out the mime component
        var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);

        // create a view into the buffer
        var ia = new Uint8Array(ab);

        // set the bytes of the buffer to the correct values
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        // write the ArrayBuffer to a blob, and you're done
        var blob = new Blob([ab], { type: mimeString });
        return blob;
    } catch (e) {
        logger.error("Error", e, dataURI);
        return dataURI;
    }
}

export const uploadToPresigned = async (body: any, presignedURL: PresignedUrl) => {
    const formData = new FormData();
    const data = { ...presignedURL };
    // data.fields.key = presignedURL.fields.key + "hello.txt"
    for (let key in data.fields) {
        formData.append(key, data.fields[key]);
    }
    formData.append("file", body);
    try {
        const resp = await fetch(data.url, { method: "POST", body: formData });
        logger.debug("UPLOADED", resp);
        if (!resp.ok) {
            // No upload
            logger.debug("BODY OF FAILED UPLOAD", body);
        }
        return resp;
    } catch (e : any) {
        logger.debug(e, e.status);
        
        try{
            captureEvent({eventName: 'UploadError', value: {'error': JSON.stringify(e)}})
        }catch(e){
            
        }
        return Promise.resolve(null);
    }
};


class HelpCenterSaver {
    queryAPI: GigaUserApiClient;
    organization: Organization | null;
    constructor() {
        this.queryAPI = new GigaUserApiClient({environment: main_url, fetcher: fetcher})
        this.organization = null
    }

    getBrandingColor = ()=>{
        return this.organization?.brandColor
    }

    initialiseFromHostname  = async() =>{

        this.queryAPI = new GigaUserApiClient({
            token: 'ignore', 
            environment: main_url, 
            fetcher: fetcher
        })

        const organization = await this.queryAPI.helpcenterQueries.getOrganization()

        if(organization.ok){
            this.organization = organization.body
            setBranding(this.organization.brandColor)
            this.queryAPI = new GigaUserApiClient({
                token: this.organization.id, 
                environment: main_url, 
                fetcher: fetcher
            })
            
        }
        return organization
        
    }

    fetchAllGuidePreviews = async (onlyPublished = true)=>{

        const allGuides = await this.queryAPI.helpcenterQueries.getAllGuidePreviews()
        
        if (allGuides.ok){
            const guidePreviews = allGuides.body
            logger.debug("guidePreviews: ", guidePreviews)
            
            if(onlyPublished) return guidePreviews.filter(i => i.header.published===true)
            else return guidePreviews
        }
        else{
            return []
        }
    }


    fetchAllCollections = async ()=>{

        const allCollections = await this.queryAPI.helpcenterQueries.getAllCollections()
        
        if (allCollections.ok){
            const collections = allCollections.body

            return collections
            
        }
        else{
            return []
        }
    }

    fetchAllChildren = async(_parentId?: string, onlyPublished:boolean = true) =>{

        var parentId = undefined

        if(_parentId==="Collection_root"){
            parentId = undefined
        }
        else if(_parentId){
            parentId = GigaUserApi.Id(_parentId) 
        }

        const allChildren = await this.queryAPI.helpcenterQueries.getAllChildren({
            parentId: parentId
        })

        logger.debug("allChildren: ", allChildren)

        if(allChildren.ok){
            const {guides, collections} = allChildren.body
            if(onlyPublished){
                const _guides = guides.filter(g=>g.header.published)
                return{
                    guides: _guides, 
                    collections: collections
                }
            }
            else{
                return allChildren.body
            }
        }
        else{
            return {
                guides: [], 
                collections: []
            }
        }

    }

    getPath = async(id: string) =>{

        logger.debug("saver getPath: ", id)
        
        const res = await this.queryAPI.helpcenterQueries.getPath({
            id: GigaUserApi.Id(id)
        })

        if(res.ok){
            var path = res.body.collections
            const full_path = [rootCollection, ...path]

            logger.debug("got path: ", full_path)

            return full_path as [Collection, ...Collection[]]
        }

        else{
            return false
        }
    }

    

    validateToken = async (token: string)=>{
        return await this.queryAPI.helpcenterQueries.validateToken({tokenId: token})
    }

    search = async (text: string)=>{
        const searchResults = await this.queryAPI.helpcenterQueries.search({text: text})
        if(searchResults.ok){
            return searchResults.body
        }
        else{
            return []
        }
    }

    fetchGuideData = async (id: GigaUserApi.Id)=>{
        // logger.debug("CLIENT API", thi)

        const rootGuides = await this.queryAPI.helpcenterQueries.getGuideData({
            id: id
        })
        if (rootGuides.ok){
            const guideData = rootGuides.body
            if (guideData.video.metadata.generatedVideo?.subtitles){
                const blob = new Blob([guideData.video.metadata.generatedVideo?.subtitles], { type: 'text/vtt' });
                guideData.video.metadata.generatedVideo.subtitles = URL.createObjectURL(blob);
            }
            return guideData
        }
        else{
            return null
        }

    }

    fetchGuidePreview = async(id: GigaUserApi.Id ) =>{
        
        const res = await this.queryAPI.helpcenterQueries.getGuidePreview({
            id: id
        })

        if(res.ok){
            const guidePreview = res.body
            return guidePreview
        }
        else{
            return null
        }

    }


}

export const helpSaver = new HelpCenterSaver()

